import { IAction } from '~/src/store';

import { initialPopupState, IPopupState } from '../reducer';

import { EChangePaymentDateActions } from './index';

export type TSetClosePopup = IAction<EChangePaymentDateActions.SET_CLOSE_POPUP, IPopupState>

const setClosePopup = (): TSetClosePopup => ({
    type: EChangePaymentDateActions.SET_CLOSE_POPUP,
    payload: initialPopupState,
});

export default setClosePopup;
